import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { apiUrl } from '../config/api';

function EditUserForm({ user, onClose, onSuccess }: { user: any; onClose: () => void; onSuccess: () => void }) {
  const token = useSelector((state: RootState) => state.auth.token);

  const [username, setUsername] = useState(user.username);
  const [email, setEmail] = useState(user.email);
  const [role, setRole] = useState(user.role);
  const [password, setPassword] = useState('');
  const [employedSince, setEmployedSince] = useState(
    user.employedSince ? user.employedSince.slice(0, 10) : ''
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleUpdate = async () => {
    const confirmed = window.confirm('Willst du die Änderungen wirklich speichern?');
    if (!confirmed) return;

    setLoading(true);
    setError('');

    try {
      const res = await fetch(apiUrl(`/api/users/${user._id}`), {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          username,
          email,
          role,
          password: password || undefined,
          employedSince: employedSince || undefined,
        }),
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message || 'Fehler beim Aktualisieren');
      }

      alert('Benutzer erfolgreich aktualisiert.');
      onSuccess();
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
      setPassword('');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="card p-4 shadow-sm" style={{ maxWidth: 400, margin: 'auto' }}>
        <h4 className="mb-3">Benutzer bearbeiten</h4>

        {error && <div className="alert alert-danger">{error}</div>}

        <input
          className="form-control mb-2"
          placeholder="Benutzername"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          disabled={loading}
        />
        <input
          className="form-control mb-2"
          placeholder="E-Mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={loading}
        />
        <select
          className="form-select mb-2"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          disabled={loading}
        >
          <option value="user">User</option>
          <option value="admin">Admin</option>
        </select>
        <input
          className="form-control mb-3"
          type="password"
          placeholder="Neues Passwort (optional)"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={loading}
        />
        <label className="form-label">Beschäftigt seit</label>
        <input
          className="form-control mb-3"
          type="date"
          value={employedSince}
          onChange={(e) => setEmployedSince(e.target.value)}
          disabled={loading}
        />

        <div className="d-flex justify-content-between">
          <button className="btn btn-secondary" onClick={onClose} disabled={loading}>
            Abbrechen
          </button>
          <button className="btn btn-primary" onClick={handleUpdate} disabled={loading}>
            {loading ? 'Speichern...' : 'Speichern'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditUserForm;
